<template>
  <BaseModal
        :id="'static-assignment-note'"
        :title="title"
        :message='message'
        :size="'lg'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit()">
                <FormDynamic
                  :form_format="form_format"
                  :form_data="form_data"
                  :array_options="array_options"
                  :for_update="false"
                />

                <hr/>
                    <div class="modal-title w-100">
                        <h2 class="title--1" v-html="'Assignments'" style="font-size:18px;"/>
                    </div>
                    <div class="w-100 table-responsive defaultproject__table overflow-y--1" v-if="daily_assignments_collection.length">
                        <table class="table">
                            <thead style="background-color: #f1f1f1;">
                                <tr>
                                    <th v-for="(item, i) in table_headers" :key="i" scope="col" v-html="item.name" style="padding-top:30px; padding-right:0px"/>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, i) in daily_assignments_collection" :key="i">
                                    <td style="padding:15px;">
                                        <span class="custom-control custom-checkbox">
                                            <input 
                                                :id="`checked${i}`"
                                                type="checkbox" 
                                                class="custom-control-input" 
                                                v-model="item.checked" 
                                                :disabled="form_data.all_assignments"
                                                @change="checkValidator()"
                                            />
                                            <label :for="`checked${i}`" class="custom-control-label ml-2"/>
                                        </span>
                                    </td>
                                    <td v-html="item.number_assigment"/>
                                    <td v-html="item.description"/>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                <hr/>
                <div class="modal__buttons text-center text-md-right">
                    <button type="button" class="modal__buttons__item cancel" data-dismiss="modal" aria-label="Close" v-html="'Cancel'"/>
                    <button class="modal__buttons__item" v-html="`Confirm`"/>
                </div>
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources  from './form_resources'
import Resources      from './resources'
import FormDynamic    from '@/components/FormDynamic.vue'
import Breadcrumb     from '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal      from '@/components/BaseModal'
// import CentralButtons from '@/components/CentralButtons'
// import eventBus       from '@/plugins/eventBus'

export default {

    name: "FormModalNote",

    props: [
        'title',
        'rest_api',
        'notyf',
        'array_options',
        'breadcrumb',
        'daily_assignments_collection'
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        // CentralButtons,
    },

    data(){
        return{
            form_data:   FormResources.form_data_note,
            form_format: FormResources.form_format_note,
            form_backup: {...FormResources.form_data_note},
            message:  'Create notes to display on all assignments, multiple assignments, or an individual assignment.',
            table_headers: Resources.note_table_headers,
        }
    },

    watch: {

        'form_data.all_assignments'(val)
        {
            this.daily_assignments_collection.map(item => item.checked = val)
        }
    },

    methods: {

        checkValidator()
        {
            if(this.form_data.all_assignments)
            {
                this.daily_assignments_collection.map((item, i) => {
                    item.checked = true
                    window.$(`#checked${i}`).prop('checked', true)
                })
            }
        },

        async form_submit() 
        {
            let filter = this.form_data.daily_assignment_id = this.daily_assignments_collection.filter(item => item.checked)

            if(!filter.length)
            {
                this.notyf.error('Select at least an assignment')
                return false
            }
            this.form_data.daily_assignment_id = filter.map(item => item.id)

            this.loader(true)

            const response  = await this.post(this.rest_api, this.form_data)

            if(response.status)
            {
                this.form_data = {...this.form_backup}
                this.notyf.success('Success')
                this.loader()
                this.$emit('noteCreated', response.data.data)
                window.$('#static-assignment-note').modal('hide')
            }
            else
            {
                this.error_handling(response)
                this.loader()
            }
        },

    },

    mounted(){},
}
</script>